import { TranslocoService } from '@jsverse/transloco';
import { inject, LOCALE_ID, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { LanguageService } from '@core/services';

function preloadLang() {
  const transloco = inject(TranslocoService);
  const lang = LanguageService.readPreferredLanguage();
  transloco.setActiveLang(lang);
  return transloco.load(lang);
}

function preloadLangInitializer() {
  return provideAppInitializer(preloadLang);
}

export const preloadLocalId = {
  provide: LOCALE_ID,
  useFactory: (languageService: LanguageService) => languageService.getSelectedLanguage(),
  deps: [LanguageService],
};

export function providePreloadLang() {
  return makeEnvironmentProviders([preloadLangInitializer(), preloadLocalId]);
}
